function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M12 15.57H4a.267.267 0 0 0-.267.267v.267c0 .294.239.533.533.533h7.467a.534.534 0 0 0 .533-.533v-.267A.267.267 0 0 0 12 15.57z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M5.067 15.037h5.866a1.6 1.6 0 0 0-1.6-1.6H6.667a1.6 1.6 0 0 0-1.6 1.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M8.533 3.304V1.17a.52.52 0 0 0-.157-.376A.52.52 0 0 0 8 .637a.535.535 0 0 0-.534.533v11.734h1.067z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M.8 3.304h1.099c.192.187.423.327.677.413L.626 8.104h.584l1.723-3.878 1.723 3.878h.584L3.297 3.732c.261-.079.497-.226.681-.428h2.955V2.237h-3.2a.537.537 0 0 0-.426.213c-.073.096-.214.26-.342.262h-.003a.686.686 0 0 1-.402-.262.537.537 0 0 0-.427-.213H.8a.533.533 0 1 0 0 1.067z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M12.703 3.732L10.76 8.104h.584l1.722-3.878 1.723 3.878h.584l-1.95-4.387c.254-.086.486-.226.678-.413H15.2a.533.533 0 0 0 0-1.067h-1.334a.537.537 0 0 0-.426.213.687.687 0 0 1-.403.262h-.002c-.128-.003-.27-.166-.342-.262a.537.537 0 0 0-.427-.213h-3.2v1.067h2.955c.185.202.42.35.682.428z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M5.6 9.97V8.904a.267.267 0 0 0-.267-.267h-4.8a.267.267 0 0 0-.267.267V9.97A1.332 1.332 0 0 0 1.6 11.304h2.666c.737 0 1.334-.597 1.334-1.334z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M15.466 8.637h-4.8a.267.267 0 0 0-.266.267V9.97c0 .737.597 1.334 1.333 1.334H14.4c.736 0 1.333-.597 1.333-1.334V8.904a.267.267 0 0 0-.267-.267z"
}))))));

var SvgIconLawyerSra = function SvgIconLawyerSra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLawyerSra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-lawyer-sra.e182182f.svg";
export { ForwardRef as ReactComponent };